export default __webpack_public_path__ + "33c4ac5f5419ad1fc0f76b038b5792bb.png";